export const buttons ={
    "confirm": "אישור",
    "cancel": "ביטול",
    "approve": "לְאַשֵׁר",
}
